<template>
  <div>
    <div class="-content d-flex align-items-start flex-column mt-4 w-100">
      <div class="page-global-header px-0 w-100">
        <div class="row mx-0 justify-content-center">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
            <div class="global-searchbar">
              <div class="base-form">
                <div class="input-group">
                  <div class="input-group-text">
                    <img src="@/assets/images/system/groups.svg" />
                  </div>
                  <input type="search" name="globalSearch" class="form-control"
                    placeholder="Search (Vendor name, expense number etc)" v-model="search.search_text" />
                  <button type="button" name="btnSearch" class="btn btn-primary">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 d-flex align-items-center justify-content-end"
            style="padding-right: 200px;">
            <ul class="search-option-menu me-3">
              <li class="nav-item">
                <XlsToggle v-model="xlsView" title="Switch between XLS grid and default expense list" />
              </li>
              <li class="nav-item sorting">
                <input type="checkbox" class="sorting-check" v-model="expense_sorting_desc" @change="changeOrder"
                  id="btn-sorting" autocomplete="off" />
                <label class="btn btn-sorting" for="btn-sorting"><span class="sr-only">Sort</span>
                </label>
              </li>
              <li class="nav-item">
                <router-link to="/add-expense" class="nav-link circleNav"><i class="fa fa-plus"></i>
                </router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  href="#"
                  class="nav-link dropdown-toggle no-caret"
                  id="optionMore"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fa fa-ellipsis-v"></i>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-end _v1"
                  aria-labelledby="optionMore"
                >
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generatePdf"
                      >PDF <i class="fa fa-envelope append"></i>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generateExcel"
                      >Download Excel <i class="fa fa-download append"></i>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generateZip"
                      >Download Zip <i class="fa fa-download append"></i>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="clearfix"></div>

          <div class="global-filter-form">
            <form class="base-form form-xl">
              <div class="row mx-0 g-2 d-flex justify-content-center mt-2 flex-nowrap">
                <div class="col-auto" style="min-width: 150px;">
                  <div class="form-floating">
                    <input type="date" name="datepick" id="startDate"
                      class="form-control datepicker text-end text-danger _3d-input chevron-circle"
                      v-model="search.date[0]" @change="getData(1)" onfocus="this.showPicker()"
                      data-date-format="mm/dd/yyyy" />
                    <label for="startDate" class="w-100 text-center">Start date</label>
                  </div>
                </div>

                <div class="col-auto" style="min-width: 150px;">
                  <div class="form-floating">
                    <input type="date" name="datepick" id="endDate"
                      class="form-control datepicker text-end text-danger _3d-input chevron-circle"
                      v-model="search.date[1]" @change="getData(1)" onfocus="this.showPicker()"
                      data-date-format="mm/dd/yyyy" />
                    <label for="endDate" class="w-100 text-center">End date</label>
                  </div>
                </div>

                <div class="col-auto" style="min-width: 260px;">
                  <select class="form-select _3d-input text-black" v-model="search.category" @change="getData(1)">
                    <option selected="" disabled="" value="">
                      Select Expense Category (All)
                    </option>
                    <option v-for="item in expenseCategoryServer" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>

                <div class="col-auto" style="min-width: 220px;">
                  <select class="form-select _3d-input text-black" v-model="search.currency" @change="getData(1)">
                    <option value="">
                      Select Currency
                    </option>
                    <option v-for="item in currencyOptions" :key="item.id" :value="item.id">
                      {{ item.currency }} ({{ item.symbol }})
                    </option>
                  </select>
                </div>

                <div class="col-auto" style="min-width: 220px;">
                  <select class="form-select _3d-input text-black" v-model="search.payment_method" @change="getData(1)">
                    <option value="">
                      Payment Method (All)
                    </option>
                    <option v-for="item in payment_method" :key="item" :value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="page-body expenses-list-body custom-scroll">
        <div class="row mt-3 mx-0" v-if="xlsView">
          <div class="col-12">
            <ExcelGridView
              :columns="xlsColumns"
              :rows="xlsRows"
              :totals="xlsTotals"
              :currency-symbol="xlsCurrencySymbol"
              no-data-text="No expenses match the current filters."
              @cell-click="onXlsCellClick"
            />
          </div>
        </div>

        <div style="margin-top: 50px;" v-else>
          <div class="row mx-0">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
              <div class="card-list-group">
                <!--repeatable block-->
                <div class="expenses-list-single" v-for="(expense, key) in paginatedExpenses"
                  :key="'expense' + expense.id">
                  <div class="card card-horizontal-list bostonBlue mb-3">
                    <div class="card-body">
                      <div class="hover-slide">
                        <div class="form-check outliner">
                          <input class="form-check-input" type="checkbox" value="" />
                        </div>
                      </div>
                      <div class="card-content count-inline">
                        <ul class="label-list">
                          <li class="list-title"><span class="card-count">{{ (currentPage - 1) * pageSize + key + 1 }}.</span>Ex.No: {{ expense.expense_no }}</li>
                          <li class="sub-title">C: {{ expense.category }}</li>
                          <li class="text-danger">D: {{ $formatDate(expense.expense_date) }}</li>
                          <li>V: {{ expense.vendor }}</li>
                        </ul>
                      </div>
                      <div class="content-option w-auto">
                        <div class="row m-0 h-100 justify-content-between flex-column">
                          <ul class="card-action-nav h-auto">
                            <li class="nav-item">
                              <span class="btn btn-success btn-sm-x" style="cursor: default;">{{
                                expense.payment_type
                              }}</span>
                            </li>
                          </ul>
                          <ul class="card-action-nav h-auto flex-row flex-nowrap">
                            <li class="nav-item">
                              <template v-if="hasAttachment(expense)">
                                <a href="#" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                                  data-bs-target="#expenseFile" @click="fileExpensesDetails(expense.id)"><i
                                    class="fa fa-paperclip"></i> File
                                </a>
                              </template>
                            </li>
                            <li class="nav-item ms-2">
                              <template v-if="hasNote(expense)">
                                <a href="#" class="btn btn-info btn-sm" data-bs-toggle="modal"
                                  data-bs-target="#expenseNote" @click="fileExpensesDetails(expense.id)"><i
                                    class="fa fa-edit"></i> Note
                                </a>
                              </template>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer has-action flex-shrink-1">
                      <div class="ellipsis-dropdown dropdown">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            <i class="fas fa-ellipsis-v text-white"></i>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <el-dropdown-item @click="showEditData(expense.id)"><i
                                  class="fa fa-edit"></i></el-dropdown-item>
                              <el-dropdown-item @click="deleteData(expense.id)"><i
                                  class="fa fa-times text-danger"></i></el-dropdown-item>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div class="footer-list-wraper justify-content-end">
                        <ul class="footer-list _big" style="width: auto; white-space: nowrap;">
                          <li>Amount</li>
                          <li class="count" style="text-align: right;">
                            {{ getCurrencyName(expense.currency_id) }}
                            {{ parseFloat(expense.amount).toFixed(2) }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mx-0 justify-content-center" v-if="search.currency">
                <div class="col-12">
                  <div class="d-flex justify-content-end mb-3 mt-5">
                    <div class="input-group input-group--3d group-half p-0 amount-paid-box" style="max-width: 280px;">
                      <div class="input-group-text bg-orange no-after">
                        Amount Paid
                      </div>
                      <div class="form-floating">
                        <label class="floating-label">{{
                          search.currency ? getCurrencyName(search.currency) : ($auth.user?.currency || '')
                        }}</label>
                        <input class="form-control text-right" type="text" :value="filteredExpenses
                            .reduce((total, expense) => {
                              // Convert the amount to a number before adding
                              return total + (parseFloat(expense.amount) || 0);
                            }, 0)
                            .toFixed(2)
                          " placeholder="10,000.00" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--ended repeatable block-->
            </div>
          </div>
          <!-- pagination  -->
          <div v-show="totalPages > 1">
            <ul class="pagination">
              <li class="page-item" v-if="currentPage > 1" @click="currentPage--">
                <a class="page-link" href="javascript:;">Previous</a>
              </li>
              <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === currentPage }"
                @click="currentPage = page">
                <a class="page-link" href="javascript:;">{{ page }}</a>
              </li>
              <li class="page-item" v-if="currentPage < totalPages" @click="currentPage++">
                <a class="page-link" href="javascript:;">Next</a>
              </li>
            </ul>
          </div>
          <!-- pagination end -->
        </div>

        <div class="row mx-0 mt-5" v-if="show_total_expense">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
            <div class="px-5 d-flex justify-content-end">
              <div class="col-sm-12 col-md-12 col-lg-7">
                <div class="input-group input-group--3d group-half p-0 amount-paid-box">
                  <div class="input-group-text bg-orange no-after">
                    Amount Paid
                  </div>
                  <div class="form-floating">
                    <label class="floating-label">{{ $auth.user?.currency }}</label>
                    <input class="form-control text-right" type="text" placeholder="10,000.00" value="10,000.00" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 d-flex align-items-center justify-content-center">
                        <button type="button" name="btn" class="btn btn-offWhite">Close</button>
                    </div> -->
        </div>
      </div>
    </div>

    <!--Expense File Preview Modal file-->
    <div class="modal fade mdl-messaging _info" id="expenseFile" aria-hidden="true" aria-labelledby="expenseFileLabel"
      tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Expense preview</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="message-card no-shadow m-0">
              <div class="abs-nav abs--tr me-n5">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a class="nav-link" href="#" data-bs-dismiss="modal" @click="showEditData(expenses_preview.id)"><i
                        class="fa fa-edit"></i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-print"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-envelope"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" @click="deleteData(expense.id)"><i class="fa fa-download"></i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fas fa-ban"></i> </a>
                  </li>
                </ul>
              </div>

              <div class="w-100">
                <ul class="list-group list-group--borderless list-group--compact">
                  <li class="list-group-item">
                    Expense number: {{ expenses_preview.expense_number }}
                  </li>
                  <li class="list-group-item">
                    Category: {{ expenses_preview.category }}
                  </li>
                  <li class="list-group-item">
                    Vendor name: {{ expenses_preview.vendor }}
                  </li>
                  <li class="list-group-item">Date: {{ $formatDate(expenses_preview.date) }}</li>
                  <li class="list-group-item d-flex justify-content-between">
                    <span>Payment method: {{ expenses_preview.payment_method }}</span>
                    <span>Amount:
                      {{
                        expenses_preview.currency_id
                          ? getCurrencyName(expenses_preview.currency_id)
                          : ""
                      }}
                      {{ expenses_preview.amount }}</span>
                  </li>
                </ul>
              </div>

              <div class="card card--curve-05rem mt-3 w-100 align-items-center justify-content-center">
                <div class="w-auto p-2">
                  <span v-for="(url_image, key) in expenses_preview.image_url" v-bind:key="key">
                    <img :src="url_image" class="img-fluid mb-2" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Expense File Preview Modal note-->
    <div class="modal fade mdl-messaging _info" id="expenseNote" aria-hidden="true" aria-labelledby="expenseNoteLabel"
      tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Expense preview</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="message-card no-shadow m-0">
              <div class="abs-nav abs--tr me-n5">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a class="nav-link" href="#" @click="showEditData(expenses_preview.id)"><i class="fa fa-edit"></i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-print"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-envelope"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fa fa-download"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fas fa-ban"></i> </a>
                  </li>
                </ul>
              </div>

              <div class="w-100">
                <ul class="list-group list-group--borderless list-group--compact">
                  <li class="list-group-item">
                    Expense number: {{ expenses_preview.expense_number }}
                  </li>
                  <li class="list-group-item">
                    Category: {{ expenses_preview.category }}
                  </li>
                  <li class="list-group-item">
                    Vendor name: {{ expenses_preview.vendor }}
                  </li>
                  <li class="list-group-item">Date: {{ $formatDate(expenses_preview.date) }}</li>
                  <li class="list-group-item d-flex justify-content-between">
                    <span>Payment method: {{ expenses_preview.payment_method }}</span>
                    <span>Amount:
                      {{
                        expenses_preview.currency_id
                          ? getCurrencyName(expenses_preview.currency_id)
                          : ""
                      }}
                      {{ expenses_preview.amount }}</span>
                  </li>
                </ul>
              </div>

              <template v-if="expenses_preview.note != null">
                <div class="card card--curve-05rem mt-3 w-100">
                  <div class="card-body">
                    <p class="m-0">Note:</p>
                    <p class="m-0">
                      {{ expenses_preview.note }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import XlsToggle from "@/components/partials/XlsToggle.vue";
import ExcelGridView from "@/components/partials/ExcelGridView.vue";
import {
  resolveExportFilename,
  unwrapExportUrl,
  downloadExportFromUrl,
  saveBlob,
  readBlobError,
  readRequestError,
  exportErrorMessage,
  EXPORT_PREFIX,
} from "@/utils/exportNaming";

Date.prototype.addMonths = function (months) {
  var date = new Date(this.valueOf());
  date.setMonth(date.getMonth() + months);
  return date;
};

export default {
  name: "ExpenseComponent",
  components: { XlsToggle, ExcelGridView },
  data() {
    return {
      loadingInstance: null,
      xlsView: false,
      isLoading: false,
      loadingText: "Loading...",
      show_total_expense: 0,
      expenses_server_data: [],
      expenses_server_data_unfiltred: [],
      expense_category: null,
      currency: null,
      payment_method: null,
      expenses_preview: {
        id: "",
        expense_number: "",
        category: "",
        vendor: "",
        date: "",
        payment_method: "",
        note: "",
        currency_id: "",
        amount: "",
        image_url: [],
      },
      search: {
        date: [
          new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)
            .toISOString()
            .slice(0, 10),
          new Date().toISOString().slice(0, 10),
        ],
        category: "all",
        currency: this.$store.state.auth.user?.currency_id || "",
        payment_method: "",
        search_text: "",
      },
      file_data: "",
      file_popup: false,
      note_popup: false,
      expense_category_filter: [],
      currency_filter: [],
      payment_filter: [],
      currentPage: 1,
      pageSize: 10,
      expense_sorting_desc: false,
    };
  },
  watch: {
    "search.search_text"() {
      this.currentPage = 1;
    },
  },
  mounted() {
    this.isProfileComplete = this.$store.getters["auth/getProfileCompleteStatus"];

    if (!this.isProfileComplete) {
      this.$router.push({ name: "dashboard" }); // Replace 'dashboard' with your actual route name
    }

    this.showLoading();
    // Use Promise.all to wait for both showLoading and getDropdowns to finish
    Promise.all([this.getDropdowns()]).then(() => {
      this.getData(1);
    });
  },
  computed: {
    // The search box filters the loaded list in the browser (same policy as the
    // client list) - the API ignores a search term, so asking it to filter
    // returned nothing at all.
    filteredExpenses() {
      if (!this.search.search_text) return this.expenses_server_data;

      const query = this.search.search_text.toLowerCase();
      const has = (value) => String(value ?? "").toLowerCase().includes(query);

      return this.expenses_server_data.filter((expense) => {
        return (
          has(expense.vendor) ||
          has(expense.expense_no) ||
          has(expense.category) ||
          has(expense.payment_type) ||
          has(expense.notes) ||
          has(expense.description) ||
          has(expense.note)
        );
      });
    },
    paginatedExpenses() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredExpenses.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.filteredExpenses.length / this.pageSize) || 1;
    },
    expenseCategoryServer() {
      if (this.expense_category && Array.isArray(this.expense_category)) {
        const categories = this.expense_category.map((v) => ({
          id: v.id,
          name: v.category,
        }));

        // Add "All" option at the top
        return [{ id: "all", name: "Select Expense Category (All)" }, ...categories];
      }
      return [{ id: "all", name: "Select Expense Category (All)" }];
    },
    xlsCurrencySymbol() {
      return this.search.currency
        ? this.getCurrencyName(this.search.currency) || this.$auth.user?.currency || "£"
        : this.$auth.user?.currency || "£";
    },
    xlsColumns() {
      return [
        { key: "no", label: "No.", align: "center" },
        { key: "expense_date", label: "Ex Date", align: "left", date: true },
        { key: "expense_no", label: "Ex No", align: "left" },
        { key: "category", label: "Category", align: "left" },
        { key: "vendor", label: "Vendor", align: "left" },
        { key: "attachment", label: "Attachment", align: "center", block: true },
        { key: "link", label: "Link", align: "center", link: true },
        { key: "notes", label: "Notes", align: "left" },
        { key: "payment_type", label: "Payment Method", align: "left", totalLabel: "Total" },
        { key: "amount", label: "Amount", align: "right", money: true, total: true },
      ];
    },
    xlsRows() {
      return this.filteredExpenses.map((expense, index) => {
        const hasFile = this.hasAttachment(expense);
        return {
          no: index + 1,
          expense_date: expense.expense_date,
          expense_no: expense.expense_no,
          category: expense.category,
          vendor: expense.vendor,
          attachment: hasFile ? "Yes" : "No",
          attachment_color: hasFile ? "xls-pill-yes" : "xls-pill-no",
          attachment_icon: hasFile ? "bandage" : "cross",
          link: hasFile ? "View" : "",
          notes: expense.notes || expense.description || expense.note || "",
          payment_type: expense.payment_type,
          amount: parseFloat(expense.amount) || 0,
          _id: expense.id,
        };
      });
    },
    xlsTotals() {
      return {
        amount: this.filteredExpenses.reduce(
          (sum, expense) => sum + (parseFloat(expense.amount) || 0),
          0
        ),
      };
    },
    currencyOptions() {
      if (this.currency) {
        return this.currency.map((v) => {
          return {
            id: v.id,
            currency: v.currency,
            symbol: v.symbol,
          };
        });
      }
      return [];
    },
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    async getDropdowns() {
      try {
        await this.fetchCurrency();
        await this.fetchPaymentMethod();
        await this.expenseCategory();
      } catch (error) {
        console.log(error);
        // this.$toast.error("Something went wrong. Please try again.");
      }
    },
    async expenseCategory() {
      this.expense_category = await this.$store
        .dispatch("expenses/getExpenseCategory")
        .then((res) => {
          if (res.status == 1) {
            return res.response;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    async fetchCurrency() {
      this.currency = await this.$store
        .dispatch("expenses/getUsersCurrency")
        .then((res) => {
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    async fetchPaymentMethod() {
      this.payment_method = await this.$store
        .dispatch("expenses/getPaymentOptions")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    async getData(pageNumber = 1) {
      this.showLoading();
      this.currentPage = pageNumber;
      // The full matching set is fetched in one call and paged in the browser,
      // so the search box can look through every expense and not just the ten
      // rows the server would have sent for the current page.
      const data = {
        page: 1,
        from: this.search.date[0],
        to: this.search.date[1],
        category_id: this.search.category,
        currency_id: this.search.currency,
        paymentMethod: String(this.search.payment_method),
        limit: 1000,
      };
      await this.$store
        .dispatch("expenses/getList", data)
        .then((res) => {
          if (res.data.status == 1) {
            this.expenses_server_data_unfiltred = this.expenses_server_data =
              res.data.response.data;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    hasAttachment(expense) {
      return expense.file_name != "N/A";
    },
    hasNote(expense) {
      return [expense.notes, expense.description, expense.note].some((value) => {
        if (value == null) return false;
        const text = String(value).trim();
        return text !== "" && text.toUpperCase() !== "N/A";
      });
    },
    onXlsCellClick({ key, row }) {
      if (key === "link") this.fileExpensesDetails(row._id);
    },
    getCurrencyName(id) {
      const currency = (this.currency || []).find((x) => x.id === id);
      return currency ? currency.symbol : ""; // return empty string if not found
    },
    // The ISO code (GBP, USD, ...) that the export file names start with.
    // Falls back to the account currency, then to ALL when the list is showing
    // every currency at once.
    getCurrencyCode(id) {
      const list = this.currency || [];
      const match = list.find((x) => x.id === id);
      if (match?.currency) return match.currency;

      const accountId = this.$store.state.auth.user?.currency_id;
      const account = list.find((x) => x.id === accountId);
      return account?.currency || "ALL";
    },
    exportCurrencyCode() {
      return this.getCurrencyCode(this.search.currency);
    },
    // The filter payload every export endpoint is called with. `from`/`to` are
    // sent alongside `start_date`/`end_date` because the export endpoints and
    // the list endpoint disagree on which pair they read.
    exportFilters() {
      return {
        start_date: this.search.date[0],
        end_date: this.search.date[1],
        from: this.search.date[0],
        to: this.search.date[1],
        category_id: this.search.category,
        currency_id: this.search.currency,
      };
    },
    deleteData(expenseId) {
      if (!confirm("Do you want to delete this expense?")) {
        return; // stop if user cancels
      }

      this.showLoading();
      this.$store
        .dispatch("expenses/deleteExpense", expenseId)
        .then((res) => {
          if (res.status == 1) {
            this.$toast.success("Delete Successful.");
            this.fetchCurrency();
            this.fetchPaymentMethod();
            this.expenseCategory();
            this.$nextTick(() => {
              this.getData();
            });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    fileExpensesDetails(id) {
      this.file_data = this.$store.getters["expenses/getExpense"];

      const expense = this.file_data.filter((item) => item.id === id);
      const single_expense = expense[0];
      this.expenses_preview.id = single_expense.id;
      this.expenses_preview.expense_number = single_expense.expense_no;
      this.expenses_preview.category = this.getExpenseCategoryName(
        single_expense.category_id
      );
      this.expenses_preview.vendor = single_expense.vendor;
      this.expenses_preview.date = single_expense.expense_date;
      this.expenses_preview.payment_method = single_expense.payment_type;
      this.expenses_preview.note = single_expense.notes || single_expense.description || single_expense.note || "";
      this.expenses_preview.currency_id = single_expense.currency_id;
      this.expenses_preview.amount = single_expense.amount;
      this.expenses_preview.image_url = single_expense.url;
    },
    getExpenseCategoryName(category_id) {
      return this.expense_category.find((cat) => cat.id == category_id).category;
    },
    showEditData(id) {
      this.$router.push({ name: "edit-expense", params: { id: id } });
    },
    async generatePdf() {
      this.showLoading();

      try {
        const response = await this.$store.dispatch(
          "expenses/generatePdf",
          this.exportFilters()
        );
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Defence in depth: a failure should now always be non-2xx, but a JSON
        // body arriving as HTTP 200 would otherwise be saved as a broken .pdf.
        const serverError = await readBlobError(blob);
        if (serverError) {
          this.$toast.error(serverError);
          return;
        }

        // The server names the file and counts the _n; the local name is only
        // used if Content-Disposition did not make it through.
        const filename = resolveExportFilename({
          headers: response.headers,
          currencyCode: this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.expense,
          extension: "pdf",
        });

        // Save it, then open a second copy for preview. The preview URL is kept
        // alive for a while: revoking it straight away leaves the new tab blank.
        saveBlob(blob, filename);

        const previewUrl = URL.createObjectURL(blob);
        const newTab = window.open(previewUrl, "_blank");
        if (!newTab) {
          this.$toast.info(`${filename} was downloaded. Allow popups to preview it here.`);
        }
        setTimeout(() => URL.revokeObjectURL(previewUrl), 60000);
      } catch (error) {
        console.error(error);
        const message = await readRequestError(error);
        this.$toast.error(
          message || exportErrorMessage(error, "Could not generate the PDF. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async generateZip() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("expenses/generateZip", this.exportFilters());

        const zipUrl = unwrapExportUrl(res.data);
        if (!zipUrl) {
          throw new Error("No ZIP file URL returned from API.");
        }

        const filename = resolveExportFilename({
          fileName: res.data?.file_name,
          currencyCode: this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.expense,
          extension: "zip",
        });

        await downloadExportFromUrl(zipUrl, filename);
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the ZIP file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async generateExcel() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch(
          "expenses/generateExcel",
          this.exportFilters()
        );
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const serverError = await readBlobError(blob);
        if (serverError) {
          this.$toast.error(serverError);
          return;
        }

        saveBlob(
          blob,
          resolveExportFilename({
            headers: res.headers,
            currencyCode: this.exportCurrencyCode(),
            prefix: EXPORT_PREFIX.expense,
            extension: "xlsx",
          })
        );
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the Excel file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    changeOrder() {
      if (this.expense_sorting_desc) {
        // Sort data in descending order
        this.expenses_server_data.sort(
          (a, b) => new Date(b.expense_date) - new Date(a.expense_date)
        );
      } else {
        // Sort data in ascending order
        this.expenses_server_data.sort(
          (a, b) => new Date(a.expense_date) - new Date(b.expense_date)
        );
      }
    },
  },
};
</script>

<style scoped>
.expenses-list-body .expenses-list-single {
  min-height: 150px;
  width: 100%;
}

/* Match the 7px white edge on the right of the amount input */
.amount-paid-box .input-group-text {
  border-left-width: 7px;
}

.my-spinner {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.custom-scroll {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
